import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { AuthState } from 'app/core/auth/core/auth.state';
import { LogService } from 'app/core/logger';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
    selector: '[odqHideMenuIfUnauthorized]',
    standalone: false
})
export class HideMenuIfUnauthorizedDirective implements OnInit, OnDestroy {
  @Select(AuthState.signedIn) signedIn$: Observable<boolean>;

  @Input('odqHideMenuIfUnauthorized') menuItem: { roles: string[] }; // route to check passed in

  private destroy$ = new Subject<void>();
  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private logger: LogService,
    private store: Store) { }

  ngOnInit(): void {
    this.logger.debug('HideMenuIfUnauthorizedDirective routename...:', this.menuItem);

    this.signedIn$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isAuthorized => {
        this.logger.debug('HideMenuIfUnauthorizedDirective isAuthorized...:', isAuthorized);
        if (isAuthorized) {
          this.renderer.setStyle(this.el.nativeElement, 'display', 'block');
        } else {
          if (!!this.menuItem && !!this.menuItem.roles && this.menuItem.roles.length > 0) {
            this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
          }
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
